import QueryResults from "./QueryResults";

export default class QueryResults_Fototeca extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
  }

  getColumns() {
    let columnDefs = [
      // Filmografia
      this.fr.fieldFilmografia(),
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Media
      this.fr.fieldMedia(),
      // Num. Inv.
      this.fr.fieldList("numero_catalogo_generale_NCTN", "Inv. Num.", 1, this.dispatch.bind(this), "FOTOTECA_numero_catalogo_generale_NCTN"),
      // RVEL
      this.fr.fieldPlain("livello_RVEL", "Livello", 1),
      // ordine_per_invn
      this.fr.fieldPlain("ordine_per_invn", "Ordine per inv", 1),
      // Definizione
      this.fr.fieldPlain("definizione_oggetto_OGTD", "Definizione", 1),
      // QNTN
      this.fr.fieldPlain("numero_oggetti_elementi_QNTN", "QNTN", 1),
      // Identificazione
      this.fr.fieldList("identificazione_soggetto_SGTI", "Identificazione", 2, this.dispatch.bind(this), "FOTOTECA_identificazione_soggetto_SGTI"),
      // Titolo proprio
      this.fr.fieldPlain("label", "Titolo proprio", 2),
      // Da (crono. specifica)
      this.fr.fieldList(["nuova_cronologia", "data_da"], "Da", 2, null, null, "data_da"),
      // A (crono. specifica)
      this.fr.fieldList(["nuova_cronologia", "data_a"], "A", 2, null, null, "data_a"),
      // Nome Autore
      this.fr.fieldList("entities", "Nome Autore", 2, this.dispatch.bind(this), "FOTOTECA_fotografo", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "entities.rel_entity_id", key: "rel_entity_id" }),
    ];

    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }
}

QueryResults_Fototeca.QUERY_identificazione_soggetto_SGTI = {
  id: "QN1730994114061",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1730994114062",
      Field: {
        _path: "/identificazione_soggetto_SGTI",
        _label: "/identificazione_soggetto_SGTI",
        Name: "identificazione_soggetto_SGTI",
        Label: "identificazione_soggetto_SGTI",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "FOTOTECA_coll",
};

QueryResults_Fototeca.QUERY_numero_catalogo_generale_NCTN = {
  id: "QN1731012243823",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731012243825",
      Field: {
        _path: "/numero_catalogo_generale_NCTN",
        _label: "/numero_catalogo_generale_NCTN",
        Name: "numero_catalogo_generale_NCTN",
        Label: "numero_catalogo_generale_NCTN",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "FOTOTECA_coll",
};

QueryResults_Fototeca.QUERY_fotografo = {
  id: "QN1731012465668",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731012465690",
      Field: {
        _path: "/entities",
        _label: "/entities",
        Name: "entities",
        Label: "entities",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731012465691",
          Field: {
            _path: "/entities/relation_type_code",
            _label: "/entities/relation_type_code",
            Name: "relation_type_code",
            Label: "relation_type_code",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
            Lookup: "FOTOTECA_entities_relation_types",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "fot_princip_aufr",
          Compare: "sEQUALS",
        },
        {
          id: "QN1731012465692",
          Field: {
            _path: "/entities/label",
            _label: "/entities/label",
            Name: "label",
            Label: "label",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "FOTOTECA_coll",
};
